export default "__VITE_ASSET__BBVaub2u__"